export const tooltipPositions = {
    'top-right': (bounding: DOMRect, offsetWidth: number, right?: number) => {
        const localright = right || 0;
        const distanceToViewportRight = window.innerWidth - localright;
        const adjustedWidth =
            distanceToViewportRight < 10
                ? offsetWidth - (20 - distanceToViewportRight) // shrink just enough to leave 10px
                : offsetWidth;
        return {
            style: {
                top: bounding.bottom,
                left: bounding.left - 25,
                width: adjustedWidth,
                transform: `translateY(calc(-100% - ${bounding.height + 10}px))`
            },
            polygonStyle: {
                left: `${20 + bounding.width / 2}px`,
                borderBottomWidth: '1px',
                borderLeftWidth: '1px',
                borderBottomLeftRadius: '4px'
            },
            polygonClassName: 'bottom-[-7px] -rotate-90'
        };
    },
    'top-full': (bounding: DOMRect, offsetWidth: number, right?: number, width?: number) => {
        const localWidth = width || 0;
        console.log('localWidth', localWidth);
        const idealLeft = bounding.left + bounding.width / 2 - localWidth / 2;
        const margin = window.innerWidth * 0.05;
        const minLeft = margin;
        const maxLeft = window.innerWidth - localWidth - margin;
        const transform = 'translateY(-100%)';

        const clampedLeft = Math.max(minLeft, Math.min(idealLeft, maxLeft));
        const maxWidth = window.innerWidth - clampedLeft - margin;
        const finalWidth = Math.min(localWidth, maxWidth);
        return {
            style:
                localWidth === 0
                    ? {}
                    : {
                          top: bounding.top - 15,
                          left: clampedLeft,
                          width: `${finalWidth}px`,
                          transform
                      },
            polygonStyle: {
                left: bounding.left + bounding.width / 2 - clampedLeft - 10,
                borderBottomWidth: '1px',
                borderLeftWidth: '1px',
                borderBottomLeftRadius: '4px'
            },
            polygonClassName: 'bottom-[-10px] -rotate-90'
        };
    },
    'bottom-right': (bounding: DOMRect, offsetWidth: number) => {
        let diff = 0;
        if (bounding.left + offsetWidth > window.innerWidth) {
            diff = bounding.left + offsetWidth - window.innerWidth;
        }

        const additional = diff > 0 ? 10 : 0;
        return {
            style: {
                top: bounding.bottom + 15,
                left: bounding.left - diff - additional
            },
            polygonStyle: { left: bounding.width / 2 + diff, top: 9, borderTopRightRadius: '4px' },
            polygonClassName: `translate-y-[-100%] rotate-90`
        };
    },
    'bottom-left': (bounding: DOMRect) => ({
        style: {
            top: bounding.bottom + 10,
            right: window.innerWidth - bounding.right - 10
        },
        polygonStyle: { right: bounding.width / 2, top: 8, borderTopRightRadius: '4px', borderTopWidth: '1px', borderRightWidth: '1px' },
        polygonClassName: `top-0 translate-y-[-100%]`
    }),
    right: (bounding: DOMRect) => ({
        style: {
            top: bounding.top + bounding.height / 2,
            left: bounding.right + 15,
            transform: 'translateY(-50%)'
        },
        polygonStyle: {
            top: `calc(50% - ${10}px)`,
            borderTopWidth: '1px',
            borderLeftWidth: '1px',
            borderTopLeftRadius: '4px'
        },
        polygonClassName: `left-[-10px]`
    }),
    left: (bounding: DOMRect, offsetWidth: number, right?: number, width) => {
        const tooltipWidth = width || 200; // or measure dynamically
        const margin = 10;
        let leftPos = bounding.left - tooltipWidth - margin;
        if (leftPos < 0) {
            leftPos = bounding.right + margin; // fallback to right side
        }

        return {
            style: {
                top: bounding.top + bounding.height / 2,
                left: leftPos,
                transform: 'translateY(-50%)'
            },
            polygonStyle: {
                top: `calc(50% - ${10}px)`,
                borderBottomWidth: '1px',
                borderRightWidth: '1px',
                borderBottomRightRadius: '4px'
            },
            polygonClassName: 'right-[-10px]'
        };
    }
};

export const getTooltipPosition = (
    bounding: DOMRect,
    offsetWidth = 340,
    forceBelow = false,
    customPosition?: keyof typeof tooltipPositions,
    right?: number,
    width?: number
) => {
    if (customPosition) {
        return tooltipPositions[customPosition](bounding, offsetWidth, right, width);
    }

    if (!forceBelow && bounding.right + 300 < window.innerWidth) return tooltipPositions['top-right'](bounding);

    return tooltipPositions['bottom-right'](bounding, offsetWidth);
};
